var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "charts-graphic" },
    [
      _c("div", { staticClass: "sub-header" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c("md-icon", [_vm._v("help")]),
            _vm._v(" "),
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("chatbotv2." + _vm.subTitle)) +
                  "\n            "
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _c(
            "div",
            { staticClass: "export-button", on: { click: _vm.exportToCsv } },
            [
              _c("md-icon", [_vm._v("system_update_alt")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("chatbotv2.exportToCsv")))]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "export-button", on: { click: _vm.exportToExcel } },
            [
              _c("md-icon", [_vm._v("system_update_alt")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("chatbotv2.exportToExcel")))]),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("v-chart", { attrs: { options: _vm.heatmap, width: "90%" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }